export default __webpack_public_path__ + "static/Food3-6b7786f717d291ef013af063ce007a55.jpg";